import { render, staticRenderFns } from "./ApiTokenDeleteModal.vue?vue&type=template&id=3f156532&scoped=true"
import script from "./ApiTokenDeleteModal.vue?vue&type=script&lang=js"
export * from "./ApiTokenDeleteModal.vue?vue&type=script&lang=js"
import style0 from "@/components/modal/BasicModal.scss?vue&type=style&index=0&id=3f156532&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f156532",
  null
  
)

export default component.exports